import { Component, ErrorHandler, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-patient-view-grid',
  templateUrl: './patient-view-grid.component.html',
  styleUrls: ['./patient-view-grid.component.css']
})
export class PatientViewGridComponent implements OnInit {

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) 
 { }
 PD: any={};
  ngOnInit() {
  }

//  [routerLink]="['/home/PatientView/PatientView-form',PL.PR_Id]"
  
 
  
}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/patientprofile-view/patient-view-grid/patient-view-grid.component.ts